<template>
  <div class="page-content">
    <!-- <div class="content">
    <button class="icon" @click="myFunction()">
      <fa-icon :icon="{ prefix: 'fas', iconName: 'bars' }" />
    </button>
    </div> -->
    <div class="filter_content" id="filter_content">

      <div :class="{ div_btn: ModelInvestir == false, active: ModelInvestir == true}" v-on-clickaway="awayProjet">
        <button class="btn" @click="ModelInvestir = true">
          <svg xmlns="http://www.w3.org/2000/svg" width="27.5" height="18" viewBox="0 0 27.5 22" style="margin-right: 15px;vertical-align: bottom;">
            <path id="Icon_awesome-project-diagram" data-name="Icon awesome-project-diagram" d="M16.5,13.75H11a1.375,1.375,0,0,0-1.375,1.375v5.5A1.375,1.375,0,0,0,11,22h5.5a1.375,1.375,0,0,0,1.375-1.375v-5.5A1.375,1.375,0,0,0,16.5,13.75ZM8.25,1.375A1.375,1.375,0,0,0,6.875,0h-5.5A1.375,1.375,0,0,0,0,1.375v5.5A1.375,1.375,0,0,0,1.375,8.25H5.488l3.144,5.5A2.741,2.741,0,0,1,11,12.375h.012L8.25,7.541V5.5h9.625V2.75H8.25ZM26.125,0h-5.5A1.375,1.375,0,0,0,19.25,1.375v5.5A1.375,1.375,0,0,0,20.625,8.25h5.5A1.375,1.375,0,0,0,27.5,6.875v-5.5A1.375,1.375,0,0,0,26.125,0Z" fill="#ff8c00"/>
          </svg>
          <span> Projet</span>
          <fa-icon class="color" style="color:#ffffff !important;margin-left: 15px;vertical-align: bottom;" :icon="{ prefix: 'fas', iconName: 'chevron-down' }"/>
        </button>
        <ModelProjet 
          :show="ModelInvestir"
          :habiter="Habiter"
          :ancien="Ancien"
          :investir="Investir"
          :pinel="Pinel"
          :lmnp="Lmnp"
          :lmnpAmort="LmnpAmort"
          :lmnpCensi="LmnpCensi"
          @selectedProject="getProject"/>      
      </div>

      <div :class="{div_btn: ModelLocation == false, active: ModelLocation == true}" v-on-clickaway="awayLocation">
        <button class="btn" @click="ModelLocation = true">
          <svg xmlns="http://www.w3.org/2000/svg" width="16.5" height="18" viewBox="0 0 16.5 22" style="margin-right: 15px;vertical-align: bottom;">
            <path id="Icon_awesome-map-marker-alt" data-name="Icon awesome-map-marker-alt" d="M7.4,21.556C1.159,12.505,0,11.576,0,8.25a8.25,8.25,0,0,1,16.5,0c0,3.326-1.159,4.255-7.4,13.306a1.032,1.032,0,0,1-1.7,0Zm.848-9.869A3.438,3.438,0,1,0,4.813,8.25,3.437,3.437,0,0,0,8.25,11.688Z" fill="#ff8c00"/>
          </svg>
          <span>Localisation</span>
          <fa-icon class="color" style="color:#ffffff !important;margin-left: 15px;vertical-align: bottom;" :icon="{ prefix: 'fas', iconName: 'chevron-down' }"/>
        </button>
        <ModelLocation :show="ModelLocation" :location="locationProjet" @change="outsideL" @selectedLocation="getLocation" @unselectLocation="removeLocation"/>
      </div>

      <div :class="{ div_btn: ModelBudget == false, active: ModelBudget == true }" v-on-clickaway="awayBudget">
        <button class="btn" @click="ModelBudget = true">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 22 22" style="margin-right: 15px;vertical-align: bottom;">
            <path id="Icon_material-euro-symbol" data-name="Icon material-euro-symbol" d="M19.167,23.444a7.92,7.92,0,0,1-7.04-4.278h7.04V16.722H11.32a7.688,7.688,0,0,1,0-2.444h7.847V11.833h-7.04a7.929,7.929,0,0,1,12.21-2.359L26.5,7.311A10.984,10.984,0,0,0,8.8,11.833H4.5v2.444H8.24a10.222,10.222,0,0,0,0,2.444H4.5v2.444H8.8a10.984,10.984,0,0,0,17.7,4.522l-2.176-2.163a7.829,7.829,0,0,1-5.158,1.919Z" transform="translate(-4.5 -4.5)" fill="#ff8c00"/>
          </svg>

            <span>Prix total</span>
          <fa-icon class="color" style="color:#ffffff !important;margin-left: 15px;vertical-align: bottom;" :icon="{ prefix: 'fas', iconName: 'chevron-down' }"/>
        </button>
        <ModelBudget :show="ModelBudget" 
                     :MinBudgetPT="minBudgetPT" 
                     :MaxBudgetPT="maxBudgetPT" 
                     :MinBudgetPM="minBudgetPM" 
                     :MaxBudgetPM="maxBudgetPM" 
                     @change="getBudget" @budgets="displayBudgets"/>
      </div>

      <div :class="{ div_btn: ModelType == false, active: ModelType == true }" v-on-clickaway="awayType">
        <button class="btn" @click="ModelType = true">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 19.25 22" style="margin-right: 15px;vertical-align: bottom;">
            <path id="Icon_awesome-building" data-name="Icon awesome-building" d="M18.734,20.625h-.859V1.031A1.031,1.031,0,0,0,16.844,0H2.406A1.031,1.031,0,0,0,1.375,1.031V20.625H.516A.516.516,0,0,0,0,21.141V22H19.25v-.859A.516.516,0,0,0,18.734,20.625ZM5.5,3.266a.516.516,0,0,1,.516-.516H7.734a.516.516,0,0,1,.516.516V4.984a.516.516,0,0,1-.516.516H6.016A.516.516,0,0,1,5.5,4.984Zm0,4.125a.516.516,0,0,1,.516-.516H7.734a.516.516,0,0,1,.516.516V9.109a.516.516,0,0,1-.516.516H6.016A.516.516,0,0,1,5.5,9.109ZM7.734,13.75H6.016a.516.516,0,0,1-.516-.516V11.516A.516.516,0,0,1,6.016,11H7.734a.516.516,0,0,1,.516.516v1.719A.516.516,0,0,1,7.734,13.75ZM11,20.625H8.25V17.016a.516.516,0,0,1,.516-.516h1.719a.516.516,0,0,1,.516.516Zm2.75-7.391a.516.516,0,0,1-.516.516H11.516A.516.516,0,0,1,11,13.234V11.516A.516.516,0,0,1,11.516,11h1.719a.516.516,0,0,1,.516.516Zm0-4.125a.516.516,0,0,1-.516.516H11.516A.516.516,0,0,1,11,9.109V7.391a.516.516,0,0,1,.516-.516h1.719a.516.516,0,0,1,.516.516Zm0-4.125a.516.516,0,0,1-.516.516H11.516A.516.516,0,0,1,11,4.984V3.266a.516.516,0,0,1,.516-.516h1.719a.516.516,0,0,1,.516.516Z" fill="#ff8c00"/>
          </svg>
          <span>Type</span>
          <fa-icon class="color" style="color:#ffffff !important;margin-left: 15px;vertical-align: bottom;" :icon="{ prefix: 'fas', iconName: 'chevron-down' }"/>
        </button>
        <ModelType :show="ModelType"
                   :type="valueType"
                   :typologie="valueTypologie" 
                   @change="getType"
                   @types="displayTypes" />
      </div>

      <div :class="{div_btn: ModelSurface == false,active: ModelSurface == true}" v-on-clickaway="awaySurface">
        <button class="btn" @click="ModelSurface = true">
         <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 24 24" style="margin-right: 15px;vertical-align: bottom;">
          <path id="Icon_awesome-ruler-combined" data-name="Icon awesome-ruler-combined" d="M7.5,13.5H4.875a.375.375,0,0,1-.375-.375v-.75A.375.375,0,0,1,4.875,12H7.5V9H4.875A.375.375,0,0,1,4.5,8.625v-.75A.375.375,0,0,1,4.875,7.5H7.5v-3H4.875A.375.375,0,0,1,4.5,4.125v-.75A.375.375,0,0,1,4.875,3H7.5V1.5A1.5,1.5,0,0,0,6,0H1.5A1.5,1.5,0,0,0,0,1.5v21a1.443,1.443,0,0,0,.074.366L7.5,15.44Zm15,3H21v2.625a.375.375,0,0,1-.375.375h-.75a.375.375,0,0,1-.375-.375V16.5h-3v2.625a.375.375,0,0,1-.375.375h-.75A.375.375,0,0,1,15,19.125V16.5H12v2.625a.375.375,0,0,1-.375.375h-.75a.375.375,0,0,1-.375-.375V16.5H8.561L1.134,23.926A1.447,1.447,0,0,0,1.5,24h21A1.5,1.5,0,0,0,24,22.5V18A1.5,1.5,0,0,0,22.5,16.5Z" fill="#ff8c00"/>
        </svg>


            <span>Surface</span>
          <fa-icon class="color" style="color:#ffffff !important;margin-left: 15px;vertical-align: bottom;" :icon="{ prefix: 'fas', iconName: 'chevron-down' }"/>
        </button>
        <ModelSurface :show="ModelSurface" 
                      :minSurfaceHabi="minSurfaceHab"
                      :maxSurfaceHabi="maxSurfaceHab" 
                      @change="searchBySurface" @surfaces="getSurfaces" />
      </div>

      <div :class="{ div_btn: ModelStar == false, active: ModelStar == true }" v-click-outside="outsideSt" >
        <button class="btn" @click="ModelStar = true">
          <fa-icon class="color" :icon="{ prefix: 'fas', iconName: 'star' }" />
          <span> Notation</span>
          <fa-icon class="color" style="color:#ffffff !important;margin-left: 15px;vertical-align: bottom;" :icon="{ prefix: 'fas', iconName: 'chevron-down' }"/>
        </button>
        <ModelNotation :show="ModelStar" @change="outsideSt" v-on-clickaway="awayNotation"/>
      </div>

      <div :class="{ div_btn: ModelCritere == false,active: ModelCritere == true}">
        <button class="btn" @click="ModelCritere = true">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="18" viewBox="0 0 25 25" style="margin-right: 15px;vertical-align: bottom;">
            <g id="Icon_feather-plus-circle" data-name="Icon feather-plus-circle" transform="translate(-1.5 -1.5)">
              <path id="Tracé_28" data-name="Tracé 28" d="M25,14A11,11,0,1,1,14,3,11,11,0,0,1,25,14Z" fill="none" stroke="#ff8c00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
              <path id="Tracé_29" data-name="Tracé 29" d="M18,12v8.8" transform="translate(-4 -2.4)" fill="none" stroke="#ff8c00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
              <path id="Tracé_30" data-name="Tracé 30" d="M12,18h8.8" transform="translate(-2.4 -4)" fill="none" stroke="#ff8c00" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
            </g>
          </svg>
          <span>Critères</span>
          <fa-icon class="color" style="color:#ffffff !important;margin-left: 15px;vertical-align: bottom;" :icon="{ prefix: 'fas', iconName: 'chevron-down' }"/>
        </button>
        <ModelCritere :show="ModelCritere"
                      :Etages="etage"
                      :Livraison="Livraison"
                      :Expositions="exposition"
                      :Commission="commission"
                      :zFiscale="zFiscale"
                      :valueDisponibiliteLots="valueDisponibiliteLots"
                      :Promoteur="promoteur"
                      :programme="programme"
                       @change="searchCriteres" v-on-clickaway="awayCritere"/>

        
      </div>
      
    </div>
    <div class="filters-container">
      <div class="filter" v-if="project_id != null && project_id != -1">
        <span>Nom dossier : {{nomDossier}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('project_id')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>

      <div class="filter" v-if="ProjectBien != '' && ProjectBien != 'Habiter' && ProjectBien != 'Ancien'">
        <span>Projet : {{ProjectBien}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('projet')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>

      <div class="filter" v-if="BudgetBien != 'Budget'">
        <span>{{BudgetBien}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('budget')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>

      <div class="filter" v-if="Localisation != 'Localisation'">
        <span>Localisation : {{Localisation}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('localisation')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>

      <div class="filter" v-if="TypeBien != 'Type : (tous)'">
        <span>{{TypeBien}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('typeBien')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>

      <div class="filter" v-if="surfaceBien != 'Surface' || surfaceBien == 'min= 0 m² | max= 0 m²'">
        <span>Surface : {{surfaceBien}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('surface')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>

      <div class="filter" v-if="promoteurText != ''">
        <span>Promoteur : {{promoteurText}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('promoteur')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>
      
      <div class="filter" v-if="programmeText != ''">
        <span>Programme : {{programmeText}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('programme')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>

      <div class="filter" v-if="etageText != ''">
        <span>Etage : {{etageText}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('etage')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>

      <div class="filter" v-if="expositionText != ''">
        <span>Exposition : {{expositionText}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('exposition')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>

      <div class="filter" v-if="livraisonText != ''">
        <span>Date de livraison : {{livraisonText}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('livraison')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>
      
      <div class="filter" v-if="zonefiscaleText != ''">
        <span>Zone fiscale : {{zonefiscaleText}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('zonefiscale')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>
      
      <div class="filter" v-if="disponibiliteText != ''">
        <span>Disponibilité des lots : {{disponibiliteText}}
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29.25" viewBox="0 0 29.25 29.25" @click="removeFilter('disponibilite')">
            <path id="Icon_ionic-md-close-circle" data-name="Icon ionic-md-close-circle" d="M18,3.375A14.625,14.625,0,1,0,32.625,18,14.574,14.574,0,0,0,18,3.375Zm7.313,19.89-2.048,2.047L18,20.047l-5.265,5.265-2.048-2.047L15.953,18l-5.265-5.265,2.048-2.047L18,15.953l5.265-5.265,2.048,2.047L20.047,18Z" transform="translate(-3.375 -3.375)" fill="#4e4e4e"/>
          </svg>
        </span>
      </div>

    </div>
    <div class="container">
    <div class="content">
      <div class="col2">
        <span class="text-result" v-if="totalBiens> 0">
          {{totalBiens}} Biens ({{totalRowRechBienNeuf}} programmes) correspondent à votre recherche sur {{totalProgrammes}} biens au global
        </span>
        <span class="text-result" v-else>
          Aucun bien ne correspond à votre recherche
        </span>
      </div>
      
      <div class="col2">
        <div class="Alert" v-click-outside="outsideA">
          <button class="alert" @click="ModelAlert = true">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.575" height="20.971" viewBox="0 0 17.575 20.971" style="margin-right:12px;vertical-align:bottom">
              <g id="notification" transform="translate(-42.4 0.25)">
                <g id="Groupe_5" data-name="Groupe 5" transform="translate(42.657 2.985)">
                  <g id="Groupe_4" data-name="Groupe 4" transform="translate(0)">
                    <path id="Tracé_23" data-name="Tracé 23" d="M59.656,88.948l-1.465-2.441a7.256,7.256,0,0,1-1.033-3.731V80.638a5.971,5.971,0,1,0-11.941,0v2.138a7.256,7.256,0,0,1-1.033,3.731l-1.465,2.441a.426.426,0,0,0,.366.646H59.29a.426.426,0,0,0,.366-.646Zm-15.819-.207,1.077-1.8a8.1,8.1,0,0,0,1.155-4.169V80.638a5.118,5.118,0,0,1,10.235,0v2.138a8.109,8.109,0,0,0,1.154,4.169l1.078,1.8Z" transform="translate(-42.657 -74.667)" fill="#fff" stroke="#fff" stroke-width="0.5"/>
                  </g>
                </g>
                <g id="Groupe_7" data-name="Groupe 7" transform="translate(49.481)">
                  <g id="Groupe_6" data-name="Groupe 6" transform="translate(0)">
                    <path id="Tracé_24" data-name="Tracé 24" d="M215.039,0a1.708,1.708,0,0,0-1.706,1.706V3.412a.426.426,0,0,0,.853,0V1.706a.853.853,0,1,1,1.706,0V3.412a.426.426,0,0,0,.853,0V1.706A1.708,1.708,0,0,0,215.039,0Z" transform="translate(-213.333)" fill="#fff" stroke="#fff" stroke-width="0.5"/>
                  </g>
                </g>
                <g id="Groupe_9" data-name="Groupe 9" transform="translate(49.055 17.06)">
                  <g id="Groupe_8" data-name="Groupe 8" transform="translate(0)">
                    <path id="Tracé_25" data-name="Tracé 25" d="M206.644,426.89a.427.427,0,1,0-.737.432,1.279,1.279,0,1,1-2.216,0,.427.427,0,1,0-.737-.432,2.133,2.133,0,1,0,3.69,0Z" transform="translate(-202.666 -426.68)" fill="#fff" stroke="#fff" stroke-width="0.5"/>
                  </g>
                </g>
              </g>
            </svg>

            <span class="label"> Créer une alerte</span></button
          ><ModelAlert :show="ModelAlert" :searchquery="searchQuery" :totalrows="totalRows" @change="outsideA" />
        </div>
      </div>
    </div>
    <div class="content" style="align-items: center;">
      <div class="col2 width2">
        <div class="row3">
          <button class="btn pink">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="21" viewBox="0 0 30 21" style="font-size: 20px;margin-right: 15px;">
              <path id="Icon_material-compare-arrows" data-name="Icon material-compare-arrows" d="M13.515,21H3v3H13.515v4.5l5.985-6-5.985-6V21Zm8.97-1.5V15H33V12H22.485V7.5l-5.985,6Z" transform="translate(-3 -7.5)" fill="#fff"/>
            </svg>
            <span class="label">Comparer</span>
          </button>
        </div>
      </div>
      <div class="col2 width2">
        <div class="row3">
          <button class="btn" @click="VideComparateur">
            <fa-icon :icon="{ prefix: 'fas', iconName: 'redo' }" style="font-size: 20px;margin-right: 15px;"/>
            <span class="span"> Vider le comparateur</span>
          </button>
        </div>
      </div>
      <div class="col2 width1"></div>
      <div class="col2 width3">
        <div class="row3">
          <div class="select">
            <Select
              v-model="Tri"
              :options="optionTri"
              label="nom"
              placeholder="Notre globale pondérée"
              @change="TRI"
              stylechange="selectBlue"
              style="font-size: 20px !important;"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <!-- {{ListeResultRechBienNeuf}} -->
      <div class="Card_content" v-if="Ancien == false">
        <div class="card" v-for="(item, index) in ListeResultRechBienNeuf" :key="index">
          <div class="row">
            <div class="card-blocSlide">
              <vueper-slides fixed-height="265px">
                <vueper-slide v-for="(slide, i) in item[0].images_prog" :key="i"  :image="slide" />
                <div class="ribbon ribbon-bottom-right" v-if="item[0].status_lot == 'Optionné' || item[0].status_lot == 'OPTIONED'">
                  <span>Optionné</span>
                </div>
              </vueper-slides>
          
            </div>
        
          <div class="card-blocTitle">
                <div style="background: #fbfbfb;padding: 5px 0px 5px;">
                  <fa-icon :icon="{ prefix: 'fas', iconName: (item[0].type_residence == 'Logement Collectif' || item[0].type_residence == 'Appartement') ? 'building' : 'home'}" style="font-weight:lighter;font-size:20px;"/>
                  <span style="font-size:20px;margin-top:0px">Étage {{item[0].etage}} - {{item[0].typo}} - {{Math.ceil(item[0].surf_habit)}} m² - {{item[0].livraison}} - réf. {{item[0].lot}}</span>
                </div>
                <div class="ligne"></div>
                <div class="bluecolor">Note globale du bien 18/20</div>
                <div class="cotent_star">
                  <Star label="Rentabilité locative" :occurant="5" />
                </div>
                <div class="cotent_star">
                  <Star label="Potentiel de plus-value" :occurant="1" />
                </div>
                <div class="cotent_star">
                  <Star label="Facilité de la revente" :occurant="4" />
                </div>
                <div class="cotent_star">
                  <Star label="Sécurité locative" :occurant="2" />
                </div>
                <div class="cotent_star">
                  <Star label="Attractivité du quartier" :occurant="3" />
                </div>
          </div>
          <div class="card-blocData">
              <div class="titlecolor price" style="margin-top:0px;background: rgb(251, 251, 251);padding: 5px 0px;">
                {{parseFloat(item[0].prix_immo_tva_norm).toLocaleString('fr')}} €
              </div>
              <div class="titlecolor program">{{item[0].titre_prog}}</div>
              <div class="titlecolor promoteur">{{item[0].promoteur}}</div>
              <div>{{item[0].localisation}}</div>
              <div>Surface pondérée : {{item[0].surf_pondere}} m2</div>
              <div>Commission nette :
                <template v-if="item[0].etiquette_fisc === 'LMNP' || item[0].etiquette_fisc === 'LMP'">
                    6%
                </template>
                <template v-else>
                    5%
                </template>
              </div>
              <div>
                <router-link :to="{ name: 'details', params: { id: item[0].id, item: item[0], type: 'neuf' }}">
                  <button class="comparateur">
                    <fa-icon :icon="{ prefix: 'fas', iconName: 'plus' }" style="margin-right: 10px"/>
                    Ajouter au comparateur
                  </button>
                  <button class="alert">
                    Voir détails
                    <fa-icon :icon="{ prefix: 'fas', iconName: 'chevron-right' }" style="margin-left: 10px;"/>
                  </button>
                </router-link>
              </div>
          </div>
          </div>
          
          <div class="row" v-if="item.length > 1" style="background: #22abc5 !important;margin-bottom: 15px;">
            <details class="col-12">
            <summary>
                Voir plus de lots de ce programme
            </summary>
                <b-card-text>
                    <ul class="property-childs-list">
                        <li class="row property-child new" v-for="(lot, key) in item"  :key="key">
                            <div style="display:flex">
                              <div class="col-sm-1">
                                  <template v-if="lot.type_residence === 'Logement Collectif'  || lot.type_residence == 'Appartement'">
                                      <i class="fas fa-building" style="font-size: 40px;color:#888888;"></i>
                                  </template>
                                  <template v-else>
                                      <i class="fas fa-home" style="font-size: 40px;color:#888888;"></i>
                                  </template>
                              </div>
                              <div class="col-sm-10">
                                  <div class="row btn-detail-sibling">
                                      <div class="col-md-9 property-child-title">
                                          <span>Étage {{lot.etage}} - {{lot.typo}} - {{Math.ceil(lot.surf_habit)}} m² - {{lot.livraison}} - {{lot.type_residence}} - réf. {{lot.lot}} - <strong style="color: #22abc5;">{{lot.status_lot}}</strong></span>
                                      </div>
                                  </div>
                              </div>
                            </div>
                            
                            <div class="col-sm-1" style="display: flex;">
                               
                                 <div class="col-8 mr-2">
                                   <div class="col-md-3 property-child-price ">
                                        {{parseFloat(lot.prix_immo_tva_norm).toLocaleString('fr')}} €
                                    </div>
                                    <div class="col-md-8 property-child-rate">
                                    </div>
                                    <div class="col-md-4 property-child-pricem2">
                                        Prix au m²:  {{parseFloat(lot.prix_m).toLocaleString('fr')}} €
                                    </div>
                                 </div>
                                 <div class="col-4 ml-2" style="margin-left: 25px;">
                                     <router-link :to="{ name: 'details', params: { id: lot.id, item: lot }}">
                                        <span class="btn btn-secondary btn-detail">
                                          <span>Voir détails </span>
                                          <i class="fas fa-angle-right" style="color: #fff !important"></i>
                                        </span>
                                      </router-link>
                                 </div>
                                    
                            </div>
                        </li>
                    </ul>
                </b-card-text>
            </details>
          </div>
          
        </div>
      </div>
      <div class="Card_content" v-else>
        <div class="card" v-for="(item, index) in ListeResultRechBienNeuf" :key="index">
          <div class="row">
            <div class="card-blocSlide">
              <vueper-slides fixed-height="265px">
                <vueper-slide v-for="(slide, i) in item.images_prog" :key="i"  :image="slide" />
              </vueper-slides>
            </div>
            <div class="card-blocTitle">
                  <div style="background: #fbfbfb;padding: 5px 0px 5px;">
                    <fa-icon :icon="{ prefix: 'fas', iconName: (item.type_residence == 'Logement Collectif' || item.type_residence == 'Appartement') ? 'building' : 'home'}" style="font-weight:lighter;font-size:20px;"/>
                    <span style="font-size:20px;margin-top:0px">Étage {{item.etage}} - T{{item.typo}} - {{Math.ceil(item.surf_habit)}} m²</span>
                  </div>
                  <div class="ligne"></div>
                  <div class="bluecolor">Note globale du bien 18/20</div>
                  <div class="cotent_star">
                    <Star label="Rentabilité locative" :occurant="5" />
                  </div>
                  <div class="cotent_star">
                    <Star label="Potentiel de plus-value" :occurant="1" />
                  </div>
                  <div class="cotent_star">
                    <Star label="Facilité de la revente" :occurant="4" />
                  </div>
                  <div class="cotent_star">
                    <Star label="Sécurité locative" :occurant="2" />
                  </div>
                  <div class="cotent_star">
                    <Star label="Attractivité du quartier" :occurant="3" />
                  </div>
            </div>
            <div class="card-blocData">
                <div class="titlecolor price" style="margin-top:0px;background: rgb(251, 251, 251);padding: 5px 0px;">
                  {{parseFloat(item.prix_immo_tva_norm).toLocaleString('fr')}} €
                </div>
                <div class="titlecolor program">{{item.titre_prog}}</div>
                <div class="titlecolor promoteur"></div>
                <div>{{item.localisation}}</div>
                <div>Surface : {{item.surf_habit}} m2</div>
                <div>Commission nette :
                  <template v-if="item.etiquette_fisc === 'LMNP' || item.etiquette_fisc === 'LMP'">
                      6%
                  </template>
                  <template v-else>
                      5%
                  </template>
                </div>
                <div>
                  <router-link :to="{ name: 'details', params: { id: item.id, item: item, type: 'ancien' }}">
                    <button class="comparateur">
                      <fa-icon :icon="{ prefix: 'fas', iconName: 'plus' }" style="margin-right: 10px"/>
                      Ajouter au comparateur
                    </button>
                    <button class="alert">
                      Voir détails
                      <fa-icon :icon="{ prefix: 'fas', iconName: 'chevron-right' }" style="margin-left: 10px;"/>
                    </button>
                  </router-link>
                </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="col-lg-10 col-md-9 col-xs-7" v-if="ListeResultRechBienNeuf.length!=0">
        <b-pagination v-model="page" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
      </div>
    </div>
    
    
  </div>
    
</template>

<script>
import { mapGetters, mapMutations,mapActions } from "vuex"

import ClickOutside from "vue-click-outside";
import { mixin as clickaway } from 'vue-clickaway';
import ModelProjet from "./ModelProjet";
import ModelLocation from "./ModelLocation";
import ModelBudget from "./ModelBudget";
import ModelType from "./ModelType";
import ModelSurface from "./ModelSurface";
import ModelNotation from "./ModelNotation";
import ModelCritere from "./ModelCritere";
import ModelAlert from "./ModelAlert";
import Select from "./Select";
import Star from "./Star";
// import slider from "./Slide";
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
// import Multiselect from 'vue-multiselect'
export default {
  mixins: [ clickaway ],

  data() {
    return {
      ModelInvestir: false,
      ModelLocation: false,
      ModelBudget: false,
      ModelType: false,
      ModelSurface: false,
      ModelStar: false,
      ModelCritere: false,
      ModelAlert: false,
      Tri: null,
      optionTri: [
        { value: 1, nom: "1 seul critère: Rentabilité locative" },
        { value: 2, nom: "1 seul critère: Sécurité locative" },
        { value: 3, nom: "1 seul critère: Attractivité qu quartier" },
        { value: 4, nom: "1 seul critère: Potentiel de plus-value" },
        { value: 3, nom: "1 seul critère: Facilité de la revente" },
      ],
      tab1: [
        {id: 1, src: "/img/img.PNG", montant: "18589,84", taux: "61,97", m1: "76188", m2: "TP30", m3: "25,40", m4: "0,101"},
        {id: 2, src: "/img/img.PNG", montant: "18589,84", taux: "61,97", m1: "76188", m2: "TP30", m3: "25,40", m4: "0,101"},
      ],
      occurant: 2,
      perPage:9,
      page:1,
      anciensPage:1,
      limit:9,
      totalRows: 1,

      valueProjet: { text:'Habiter', value:0 },
      valueType: { text:'Tous', value:0 },
      valueTypologie: null,
      valueCommodite: null,
      locationProjet: null,
      LocationProjet: [],
      Location: 'Localisation',
      Livraison: 0,
      crtiere1:0,
      crtiere2:0,
      crtiere3:0,
      crtiere4:0,
      crtiere5:0,
      etage:0,
      zFiscale: 0,
      valueDisponibiliteLots: 0,
      commission: null,
      exposition: null,
      minBudgetPT:10,
      maxBudgetPT:0,
      minBudgetPM:10,
      maxBudgetPM:0,
      minSurfaceHab: null,
      maxSurfaceHab: null,
      Projet : [
          { text:'Habiter', value:0 },
          { text:'Investir', value:1 },
      ],
      Type: [
          { text:'Tous', value:0 },
          { text:'Appartement',value:1 },
          { text:'Maison',value:2 },
      ],
      Typologie: [
          { text: 'Studio et T1', value: 0 },
          { text: 'T1', value: 1 },
          { text: 'T2', value: 2 },
          { text: 'T3', value: 3 },
          { text: 'T4', value: 4 },
          { text: 'T5', value: 5 },
      ],
      Critere: [
          { text: "Rentabilité locative" , value: 0 },
          { text: "Sécurité locative" , value: 1},
          { text: "Attractivité du quartier" , value: 2 },
          { text: "Potentiel de plus-value" , value: 3 },
          { text: "Facilité de la revente" , value: 4 },  
      ],
      ListeEtages: [
          { text: "Indifférent",value: 0 },
          { text: "Pas de RDC", value: 1 },
          { text: "2ème Étage et Plus", value: 2 }
      ],
      ListeExposition: [
          { text: "Indifférent", value: 0 , selected: 0},
          { text: "Pas d'Exposition", value: 1 },
          { text: "Ouest", value: 2 },
          { text: "Sud", value: 3},
          { text: "Est", value: 4 },
          { text: "Nord", value: 5 }
      ],
      Commodite: [
          { text: "Terrasse & Balcon",value: 0 },
          { text: "Parking",value: 1 },
          { text: "Loggia",value: 2 },
          { text: "Jardin",value: 3 },
      ],
      DateLivraison: [
          { text: "Indifférent(e)", value: 0 },
          { text: "Déja Livré", value: 1 },
          { text: "Cette Année", value: 2 },
          { text: "2021", value: 3 },
          { text: "2020", value: 4 }
      ],
      ZoneFiscale: [
          { text: "Indifférent", value: 0 },
          { text: "A", value: 1 },
          { text: "Abis", value: 2 },
          { text: "B1", value: 3 },
          { text: "B1 Outre-Mer (DOM)", value: 4 },
          { text: "B1 Outre-Mer (TOM)", value: 5 },
          { text: "B2", value: 6 },
          { text: "C", value: 7 }
  
      ],
      DisponibiliteLot: [
          { text: "Indifférent(e)", value: 0 },
          { text: "Disponibles", value: 1 },
          { text: "Optionnés", value: 2 }
      ],
      programme:null,
      promoteur: null,
      params: null,
      bienNeufDetails:[],
      userId: localStorage.getItem('AuthUserId'),
      currentPage: 1,
      pageOptions: [5, 10, 20, 25, 50],
      ClientZipCode: null,
      departementProjet: null,
      DepartementProjet: [],
      disableDepartment: false,
      disableLocation: false,
      activeBtn:'',
      Habiter: true,
      Investir: false,
      Pinel: false,
      Lmnp: false,
      LmnpAmort: false,
      LmnpCensi: false,
      residence:0,
      ListeResidence: [
          {text: "Toutes", value: 0, selected: 0},
          {text: "Affaire", value: 1},
          {text: "EHPAD", value: 2},
          {text: "Senior", value: 3},
          {text: "Etudiante", value: 4},
          {text: "Tourisme", value: 5},
      ],
      typeResidence: 0,
      ListeTypeResidence: [
          {text: "Neuf et Ancien", value: 0, selected: 0},
          {text: "Neuf", value: 1},
          {text: "Ancien", value: 2},
      ],
      Project:'',
      Budget: 'Budget',
      Surface: 'Surface',
      TypeText: 'Type',
      project_id : null,
      Ancien : false,
      UserRole:'',
      searchQuery:{},
      nomDossier:localStorage.getItem('clientFullname')
      
    };
  },

  created(){


  },
  mounted() {
 
    this.project_id = JSON.parse(localStorage.getItem("project_id"))
    localStorage.removeItem("Bien")
 
    this.whoami().then(res => {
        
        if(this.project_id != null) {
      this.getProjectFilters({project_id: this.project_id})
        .then(res => {
          if(this.projectFilters != false) 
          {
            this.Habiter = (this.projectFilters.habiter != null) ? true : false;
            this.Ancien = (this.projectFilters.ancien != null) ? true : false;
            this.Investir = (this.projectFilters.investir != null) ? true : false;
            this.Pinel = (this.projectFilters.pinel != null) ? true : false;
            this.Lmnp = (this.projectFilters.lmnp != null) ? true : false;
            this.LmnpAmort = (this.projectFilters.lmnpAmort != null) ? true : false;
            this.LmnpCensi = (this.projectFilters.lmnpCensi != null) ? true : false; 
            if(this.projectFilters.minBudgetPT != null) this.minBudgetPT = JSON.parse(this.projectFilters.minBudgetPT);
            if(this.projectFilters.maxBudgetPT != null) this.maxBudgetPT = JSON.parse(this.projectFilters.maxBudgetPT);
            if(this.projectFilters.minBudgetPM != null) this.minBudgetPM = JSON.parse(this.projectFilters.minBudgetPM);
            if(this.projectFilters.maxBudgetPM != null) this.maxBudgetPM = JSON.parse(this.projectFilters.maxBudgetPM);
            if(this.projectFilters.minSurfaceHab != null) this.minSurfaceHab = JSON.parse(this.projectFilters.minSurfaceHab);
            if(this.projectFilters.maxSurfaceHab != null) this.maxSurfaceHab = JSON.parse(this.projectFilters.maxSurfaceHab);
            if(this.projectFilters.locationProjet != null) this.locationProjet = JSON.parse(this.projectFilters.locationProjet);
            if(this.projectFilters.promoteur != null) this.promoteur = JSON.parse(this.projectFilters.promoteur);
            if(this.projectFilters.programme != null) this.programme = JSON.parse(this.projectFilters.programme);
            if(this.projectFilters.valueType != null) this.valueType = JSON.parse(this.projectFilters.valueType);
            if(this.projectFilters.valueTypologie != null) this.valueTypologie = JSON.parse(this.projectFilters.valueTypologie);
            if(this.projectFilters.etage != null) this.etage = JSON.parse(this.projectFilters.etage);
            if(this.projectFilters.exposition != null) this.exposition = JSON.parse(this.projectFilters.exposition);
            if(this.projectFilters.valueCommodite != null) this.valueCommodite = JSON.parse(this.projectFilters.valueCommodite);
            if(this.projectFilters.livraison != null) this.Livraison = JSON.parse(this.projectFilters.livraison);
            if(this.projectFilters.commission != null) this.commission = JSON.parse(this.projectFilters.commission);
            if(this.projectFilters.zFiscale != null) this.zFiscale = JSON.parse(this.projectFilters.zFiscale);
            if(this.projectFilters.valueDisponibiliteLots != null) this.valueDisponibiliteLots = JSON.parse(this.projectFilters.valueDisponibiliteLots);

            if(this.Ancien){
              this.rechAncienWithCritere()
            } else {
              this.rechBienWithCritere();
            }
          }
          else {
            if(this.Ancien){
              this.rechAncienWithCritere()
            }else {
              this.rechBienWithCritere();
            }
          }
        });
    }
    else {
      if(this.Ancien){
        this.rechAncienWithCritere()
      }else {
        this.rechBienWithCritere();
      }
    }

      })
    
  },
  
  computed: {
    ...mapGetters(["ListeResultRechBienNeuf", "totalRowRechBienNeuf", "totalBiens", 
                    "totalProgrammes", "ListeProgramsBienNeuf", "Location", "Localisation","projectFilters","RolesCurrentUser","locationProject",
                    "CurrentUser"
                    ]),
    
    Localisation() {
      var text=""
      if(this.locationProjet == null || this.locationProjet.length == 0)
      {
          return 'Localisation'
      } else {
        for(var i=0; i<this.locationProjet.length; i++){
            text += this.locationProjet[i].text+'  '
        }
        return text
      }
    },
    BudgetBien() {
        if(this.minBudgetPT > 0 && this.maxBudgetPT > 0 ) {
            return 'Prix Total: min = '+this.minBudgetPT+' € | max = '+this.maxBudgetPT+' €';
        }
        else if(this.minBudgetPM > 0 && this.maxBudgetPM > 0) {
            return 'Prix/m² : min = '+this.minBudgetPM+' € | max = '+this.maxBudgetPM+' €';
        }
        else if(this.minBudgetPT <= 10 && this.maxBudgetPT <= 10) {
            return 'Budget'
        } 
        else if(this.minBudgetPT > 10 && this.maxBudgetPT > 0 && this.minBudgetPM > 10 && this.maxBudgetPM > 0) {
            return 'Prix Total: min = '+this.minBudgetPT+' € | max = '+this.maxBudgetPT+' € / Prix/m²: min = '+this.minBudgetPM+' m²|max = '+this.maxBudgetPM+' m²'
        }
        else if(this.minBudgetPT > 10) {
            return 'Prix Total: min = '+this.minBudgetPT+' €'
        }
        else if(this.maxBudgetPT > 10) {
            return 'Prix Total: max = '+this.maxBudgetPT+' €'
        }
        else {
          return 'Budget'
        }
    },
    ProjectBien() {
      if(this.Habiter == true || this.Habiter == 'Habiter'){
           return 'Habiter'
      }
      if(this.Ancien == true || this.Habiter == 'Ancien'){
           return 'Ancien'
      }
      if(this.Pinel == true || this.Pinel == 'Pinel'){
        if(this.Lmnp == true || this.Lmnp == 'LMNP') {
          if(this.LmnpAmort == true || this.LmnpAmort == 'LMNP Amort') return 'LMNP Amortissement'
          else if(this.LmnpCensi == true || this.LmnpCensi == 'LMNP Censi')  return 'LMNP Censi-Bouvard'
        } else return 'Pinel'
      }
      if(this.Lmnp == true || this.Lmnp == 'LMNP') {
          if(this.LmnpAmort == true || this.LmnpAmort == 'LMNP Amort') return 'LMNP Amortissement'
          else if(this.LmnpCensi == true || this.LmnpCensi == 'LMNP Censi')  return 'LMNP Censi-Bouvard'
      }
      // this.page = 1
      return this.Project
    },
    TypeBien() {
      var text=""
      if(this.valueType.text == 'Tous') {
          if(this.valueTypologie != null) {
                
              for(var i=0; i<this.valueTypologie.length; i++){
                  text += this.valueTypologie[i].text+','
              }

              return 'Type : (tous) / Typologie : '+text
          } else {
              return 'Type : (tous)'
          }
      } else {
          if(this.valueTypologie != null && this.valueTypologie.length > 0) {
              
              for(var j=0; j<this.valueTypologie.length; j++){
                  text += this.valueTypologie[j].text+','
              }
              return 'Type : ('+this.valueType.text+') / Typologie : '+text
          } else {
              return 'Type : ('+this.valueType.text+')'
          }
      }
    },
    surfaceBien() {
      if((this.minSurfaceHab != null && this.maxSurfaceHab != null) || (this.minSurfaceHab > 0 && this.maxSurfaceHab > 0)) {
          return 'min= '+this.minSurfaceHab+' m² | max= '+this.maxSurfaceHab+' m²';
      } else if((this.minSurfaceHab == null && this.maxSurfaceHab == null) 
                  || (this.minSurfaceHab == '' && this.maxSurfaceHab == '')
                  || (this.minSurfaceHab == 0 && this.maxSurfaceHab == 0)) {
          return 'Surface'
      }
      else {
          if(this.minSurfaceHab > 0 && this.maxSurfaceHab == null) {
              return 'min= '+this.minSurfaceHab+' m²'
          }
          else if(this.maxSurfaceHab > 0 && this.minSurfaceHab == null) {
              return 'max= '+this.maxSurfaceHab+' m²'
          } else if((this.minSurfaceHab == null && this.maxSurfaceHab == null) ||
                    (this.minSurfaceHab == 0 && this.maxSurfaceHab == 0)) {
            return 'Surface'
          }
          else {
              return 'Surface'
          }
      } 
    },
    promoteurText() {
      var text=""
      if(this.promoteur != null){
        var separation = (this.promoteur.length == 1) ? ' ' : ' / '
      }
      if(this.promoteur == null || this.promoteur.length == 0)
      {
          return ''
      } else {
        for(var i=0; i<this.promoteur.length; i++){
          text += this.promoteur[i].text+''+separation
        }
        return text
      }
    },
    programmeText() {
      var text=""
      if(this.programme != null){
        var separation = (this.programme.length == 1) ? ' ' : ' / '
      }
      if(this.programme == null || this.programme.length == 0)
      {
          return ''
      } else {
        for(var i=0; i<this.programme.length; i++){
          text += this.programme[i].text+''+separation
        }
        return text
      }
    },
    etageText() {
      switch(this.etage) {
        case 1 :
          return 'Pas de RDC'
        case 2 :
          return '2ème étage et plus'
        default:
          return ''
      }
    },
    expositionText() {
       var text=""
      if(this.exposition != null){
        var separation = (this.exposition.length == 1) ? ' ' : ' / '
      }
      if(this.exposition == null || this.exposition.length == 0)
      {
          return ''
      } else {
        for(var i=0; i<this.exposition.length; i++){
          text += this.exposition[i].text+''+separation
        }
        return text
      }
    },
    livraisonText() {
      switch(this.Livraison) {
        case 1 :
          return 'Déjà livré'
        case 2 :
          return 'Cette Année'
        case 3 :
          return "D'ici fin "+parseInt(new Date().getFullYear()+1)
        case 4 :
          return "D'ici fin "+parseInt(new Date().getFullYear()+2)
        default:
          return ''
      }
    },
    commissionText() {
      if(this.commission != null) {
        return this.commission
      } else {
        return ''
      }
    },
    zonefiscaleText() {
      switch(this.zFiscale) {
        case 1 :
          return 'A'
        case 2 :
          return 'Abis'
        case 3 :
          return "B1"
        case 4 :
          return "B1 Outre-Mer (DOM)"
        case 5 :
          return "B1 Outre-Mer (TOM)"
        case 6 :
          return "B2"
        case 7 :
          return "C"
        default:
          return ''
      }
    },
    disponibiliteText() {
      switch(this.valueDisponibiliteLots) {
        case 1:
          return 'Disponibles'
        case 2:
          return 'Optionnés'
        default:
          return ''
      }
    }
  },
  components: {
    ModelProjet,
    ModelLocation,
    ModelBudget,
    ModelType,
    ModelSurface,
    ModelNotation,
    ModelCritere,
    ModelAlert,
    Select,
    Star,
    VueperSlides, VueperSlide

  },
  methods: {
    ...mapActions(["rechBienNeufWithFilter","rechBienAncienWithFilter","searchVilleByCP", "searchVilleByName","getProjectFilters","setProjectFilters","whoami"]),
    removeFilter(filter) {
      switch(filter) {
        case 'projet':
          this.Project = ''
          this.Habiter = true
          this.Investir = false
          this.Pinel = false
          this.Lmnp = false
          this.LmnpAmort = false
          this.LmnpCensi = false
          break;  

        case 'budget':
          this.minBudgetPT = 0
          this.maxBudgetPT = 0
          this.minBudgetPM = 0
          this.maxBudgetPM = 0
          if(this.Ancien){
            this.anciensPage = 1
            this.rechAncienWithCritere()
          }
          else {
            this.page = 1
            this.rechBienWithCritere()
          }
          break;

        case 'localisation':
          this.locationProjet = null
          if(this.Ancien){
            this.anciensPage = 1
            this.rechAncienWithCritere()
          }
          else {
            this.page = 1
            this.rechBienWithCritere()
          }
          break;

        case 'typeBien':
          this.valueType = { text:'Tous', value:0 }
          this.valueTypologie = null
          if(this.Ancien){
            this.anciensPage = 1
            this.rechAncienWithCritere()
          }
          else {
            this.page = 1
            this.rechBienWithCritere()
          }
          break;

        case 'surface':
          this.minSurfaceHab = null
          this.maxSurfaceHab = null
          if(this.Ancien){
            this.anciensPage = 1
            this.rechAncienWithCritere()
          }
          else {
            this.page = 1
            this.rechBienWithCritere()
          }
          break;

        case 'promoteur':
          this.promoteur = null
          if(this.Ancien){
            this.anciensPage = 1
            this.rechAncienWithCritere()
          }
          else {
            this.page = 1
            this.rechBienWithCritere()
          }
          break;

        case 'programme':
          this.programme = null
          if(this.Ancien){
            this.anciensPage = 1
            this.rechAncienWithCritere()
          }
          else {
            this.page = 1
            this.rechBienWithCritere()
          }
          break;

        case 'etage':
          this.etage = 0
          if(this.Ancien){
            this.anciensPage = 1
            this.rechAncienWithCritere()
          }
          else {
            this.page = 1
            this.rechBienWithCritere()
          }
          break;

        case 'exposition':
          this.exposition = null
          if(this.Ancien){
            this.anciensPage = 1
            this.rechAncienWithCritere()
          }
          else {
            this.page = 1
            this.rechBienWithCritere()
          }
          break;

        case 'livraison':
          this.Livraison = 0
          if(this.Ancien){
            this.anciensPage = 1
            this.rechAncienWithCritere()
          }
          else {
            this.page = 1
            this.rechBienWithCritere()
          }
          break;

        case 'zonefiscale':
          this.zFiscale = 0
          if(this.Ancien){
            this.anciensPage = 1
            this.rechAncienWithCritere()
          }
          else {
            this.page = 1
            this.rechBienWithCritere()
          }
          break;

        case 'disponibilite':
          this.valueDisponibiliteLots = 0
          if(this.Ancien){
            this.anciensPage = 1
            this.rechAncienWithCritere()
          }
          else {
            this.page = 1
            this.rechBienWithCritere()
          }
          break;

        case 'project_id':
          this.project_id = -1
          localStorage.setItem("project_id", -1)
          localStorage.removeItem('clientFullname')
          localStorage.removeItem('EmpEmail')
          localStorage.removeItem('EmpPhone')
          if(this.Ancien){
            this.anciensPage = 1
            this.rechAncienWithCritere()
          }
          else {
            this.page = 1
            this.rechBienWithCritere()
          }
          break;
      }
      
    },
    camalize(s) {
     if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    },
    setLocalStorage(project){
      localStorage.setItem("Habiter", project.habiter)
      localStorage.setItem("Investir",project.investir)
      localStorage.setItem("Pinel",project.pinel)
      localStorage.setItem("Lmnp",project.lmnp)
      localStorage.setItem("LmnpAmort",project.lmnpAmort)
      localStorage.setItem("LmnpCensi",project.lmnpCensi)
      localStorage.setItem("minBudgetPT",JSON.stringify(project.minBudgetPT))
      localStorage.setItem("maxBudgetPT",JSON.stringify(project.maxBudgetPT))
      localStorage.setItem("minBudgetPM",JSON.stringify(project.minBudgetPM))
      localStorage.setItem("maxBudgetPM",JSON.stringify(project.maxBudgetPM))
      localStorage.setItem("minSurfaceHab",JSON.stringify(project.minSurfaceHab))
      localStorage.setItem("maxSurfaceHab",JSON.stringify(project.maxSurfaceHab))
      localStorage.setItem("locationProjet",project.locationProjet)
      localStorage.setItem("promoteur",(project.promoteur))
      localStorage.setItem("programme",project.programme)
      localStorage.setItem("valueType",(project.valueType))
      localStorage.setItem("valueType",JSON.stringify(project.valueTypologie))
      localStorage.setItem("etage",JSON.stringify(project.etage))
      localStorage.setItem("exposition",project.exposition)
      localStorage.setItem("valueCommodite",JSON.stringify(project.valueCommodite))
      localStorage.setItem("Livraison",JSON.stringify(project.livraison))
      localStorage.setItem("commission",JSON.stringify(project.commission))
      localStorage.setItem("zFiscale",JSON.stringify(project.zFiscale))
      localStorage.setItem("valueDisponibiliteLots",JSON.stringify(project.valueDisponibiliteLots))
    },
    awayProjet() {
      this.ModelInvestir = false
    },
    awayLocation(){
      this.ModelLocation = false
    },
    awayBudget(){
      this.ModelBudget = false
    },
    awayType(){
      this.ModelType = false
    },
    awaySurface(){
      this.ModelSurface = false
    },
    awayCritere(){
      this.ModelCritere = false
    },
    getProject({selectedProj, residence, typeResidence}) {
      this.Project = selectedProj;
      // console.log("Here is Selected Project: ", selectedProj)
      switch (selectedProj) {
        case 'Neuf':
          this.Ancien = false;
          this.Habiter = true;
          this.Project = 'Habiter';
          this.Investir = false; 
          this.Pinel = false; 
          this.Lmnp = false; 
          this.LmnpAmort = false; 
          this.LmnpCensi = false; 
          this.residence = residence; 
          this.typeResidence = typeResidence;
          this.page = 1
          this.rechBienWithCritere();
          break;
        case 'Ancien':
          this.Ancien = true;
          this.Habiter = false;
          this.Project = 'Ancien';
          this.Investir = false; 
          this.Pinel = false; 
          this.Lmnp = false; 
          this.LmnpAmort = false; 
          this.LmnpCensi = false; 
          this.residence = residence; 
          this.typeResidence = typeResidence;
          this.page = 1
          this.rechAncienWithCritere();
          break;
        case 'Habiter':
          this.Ancien = false;
          this.Habiter = true;
          this.Project = 'Habiter';
          this.Investir = false; 
          this.Pinel = false; 
          this.Lmnp = false; 
          this.LmnpAmort = false; 
          this.LmnpCensi = false; 
          this.residence = residence; 
          this.typeResidence = typeResidence;
          this.page = 1
          this.rechBienWithCritere();
          break;

        case 'Investir':
          this.Ancien = false;
          this.Investir = true;
          this.Pinel = true;
          this.Project = 'Pinel';
          this.Habiter = false;
          this.Lmnp = false; 
          this.LmnpAmort = false; 
          this.LmnpCensi = false; 
          this.residence = residence; 
          this.typeResidence = typeResidence;
          this.page = 1
          this.rechBienWithCritere();
          break;

        case 'Pinel':
          this.Ancien = false;
          this.Investir = true;
          this.Pinel = true;
          this.Project = 'Pinel';
          this.Habiter = false;
          this.Lmnp = false; 
          this.LmnpAmort = false; 
          this.LmnpCensi = false; 
          this.residence = residence; 
          this.typeResidence = typeResidence;
          this.page = 1
          this.rechBienWithCritere();
        break;

        case 'LMNP / LMP':
          this.Ancien = false;
          this.Investir = true;
          this.Lmnp = true; 
          this.Project = 'LMNP / LMP';
          this.LmnpAmort = true; 
          this.LmnpCensi = false;
          this.Pinel = false;
          this.Habiter = false;
          this.page = 1
          this.rechBienWithCritere();
        break;

        case 'LMNP Amortissement':
          this.Ancien = false;
          this.Investir = true;
          this.LmnpAmort = true; 
          this.Lmnp = true; 
          this.Project = 'LMNP Amortissement';
          this.LmnpCensi = false; 
          this.Pinel = false;
          this.Habiter = false;
          this.page = 1
          this.rechBienWithCritere();
        break;

        case 'LMNP Censi-Bouvard':
          this.Ancien = false;
          this.Investir = true;
          this.LmnpCensi = true; 
          this.Lmnp = true;
          this.Project = 'LMNP Censi-Bouvard';
          this.LmnpAmort = false; 
          this.Pinel = false;
          this.Habiter = false;
          this.page = 1
          this.rechBienWithCritere(); 
        break;

        default: break;
      }
    },
    getLocation(value) {
      if(value == null || value.length == 0)
      {
          this.Location = 'Localisation'
      } else {
        this.Location = ""
        for(var i=0; i<value.length; i++){
            this.Location += value[i].text+'  '
        }
      }
      
      this.ModelLocation = false
      this.locationProjet = value
      if(this.Ancien == true){
        this.anciensPage = 1
        this.rechAncienWithCritere()
      }else {
        this.page = 1
        this.rechBienWithCritere()
      }
      
    },
    removeLocation(value){
      this.Location = 'Localisation';
      this.ModelLocation = false
      this.locationProjet = value
      if(this.Ancien == true){
        this.anciensPage = 1
        this.rechAncienWithCritere()
      }else {
        this.page = 1
        this.rechBienWithCritere()
      }
    },
    displayBudgets({minBudgetPT,maxBudgetPT,minBudgetPM,maxBudgetPM}){
      this.minBudgetPT = minBudgetPT
      this.maxBudgetPT = maxBudgetPT
      this.minBudgetPM = minBudgetPM
      this.maxBudgetPM = maxBudgetPM

      if((this.minBudgetPT == null || this.minBudgetPT == '') 
        && (this.maxBudgetPT == null || this.maxBudgetPT == '') 
        && (this.minBudgetPM == null || this.minBudgetPM == '')
        && (this.maxBudgetPM == null || this.maxBudgetPM == '')){
        this.Budget = 'Budget'
        this.minBudgetPT = 0;
        this.maxBudgetPT = 0;
        this.minBudgetPM = 0;
        this.maxBudgetPM = 0;
      } else {
        this.Budget = (this.minBudgetPT != null && this.minBudgetPT != '') ? this.minBudgetPT + ' min' : ''
        this.Budget += (this.maxBudgetPT != null &&  this.maxBudgetPT != '') ? ((this.minBudgetPT) ? '-'+this.maxBudgetPT + ' max' : this.maxBudgetPT + ' max') : ''
        this.Budget += (this.minBudgetPM != null &&this.minBudgetPM != '') ? ((this.minBudgetPT || this.maxBudgetPT) ? ' | '+this.minBudgetPM + '/m² min' : this.minBudgetPM + '/m² min') : ''
        this.Budget += (this.maxBudgetPM != null && this.maxBudgetPM != '') ? ((this.minBudgetPM) ? '-'+this.maxBudgetPM + '/m² max' : this.maxBudgetPM + '/m² max') : ''
      }
    },
    getBudget({minBudgetPT,maxBudgetPT,minBudgetPM,maxBudgetPM}){
      this.ModelBudget = false
      if(this.Ancien == true){
        this.anciensPage = 1
        this.rechAncienWithCritere()
      }else {
        this.page = 1
        this.rechBienWithCritere()
      }
      
    },
    displayTypes({type, typologie}){
      if(type != null){
        this.TypeText = this.camalize(type)
        if(typologie != null){
          this.TypeText += '/'+this.camalize(typologie)
        }
      }
    },
    getType({type, typologie}){
      console.log(type, typologie)
      switch (type) {
        case 'Tous':
          this.valueType = { text:'Tous',value:0 };
          break;
        case 'Maison':
          this.valueType = { text:'Maison',value:2 };
          break;
        case 'Appartement':
          this.valueType = { text:'Appartement',value:1 }
          break;
        default:
          this.valueType = null 
          break;
      }

      switch (typologie) {
        case 0:
          this.valueTypologie = [{ text: 'T1', value: 0 }];
          break;
        case 1:
          this.valueTypologie = [{ text: 'T2', value: 1 }];
          break;
        case 2:
          this.valueTypologie = [{ text: 'T3', value: 2 }];
          break;
        case 3:
          this.valueTypologie = [{ text: 'T4', value: 3 }];
          break;
        case 4:
          this.valueTypologie = [{ text: 'T5', value: 4 }];
          break;
        default:
          this.valueTypologie = null 
          break;
      }

      this.ModelType = false
      if(this.Ancien == true){
        this.anciensPage = 1
        this.rechAncienWithCritere()
      }else {
        this.page = 1
        this.rechBienWithCritere()
      }
    },
    getSurfaces({minSurface, maxSurface}){
      this.minSurfaceHab = parseFloat(minSurface);
      this.maxSurfaceHab = parseFloat(maxSurface);
      console.log(this.minSurfaceHab, this.maxSurfaceHab)

      if((this.minSurfaceHab == null || this.minSurfaceHab == '') 
        && (this.maxSurfaceHab == null || this.maxSurfaceHab == '')){
        this.Surface = 'Surface'
      } else {
        this.Surface = (this.minSurfaceHab != null && this.minSurfaceHab != '' && !isNaN(this.minSurfaceHab)) ? this.minSurfaceHab + '/m² min' : ''
        this.Surface += (this.maxSurfaceHab != null &&  this.maxSurfaceHab != '' && !isNaN(this.maxSurfaceHab)) ? ((this.minSurfaceHab) ? '-'+this.maxSurfaceHab + '/m² max' : this.maxSurfaceHab + '/m² max') : ''
      }
    },
    outsideI() {
      this.ModelInvestir = false;
    },
    outsideL() {
      this.ModelLocation = false;
       
    },
    outsideB() {
      this.ModelBudget = false;
    },
    outsideT() {
      this.ModelType = false;
    },
    outsideS() {
      this.ModelSurface = false;
    },
    searchBySurface({minSurface, maxSurface}) {
      this.minSurfaceHab = minSurface
      this.maxSurfaceHab = maxSurface
      this.ModelSurface = false
      if(this.Ancien == true){
        this.anciensPage = 1
        this.rechAncienWithCritere()
      }else {
        this.page = 1
        this.rechBienWithCritere()
      }
    },
    outsideSt() {
      this.ModelStar = false;
    },
    searchCriteres({etage, date,zoneFiscale,exposition,commission,disponibiliteLot,Type,promoteur,programmes}) {
      this.etage = etage
      this.Livraison = date
      this.zFiscale = zoneFiscale
      this.exposition = exposition
      this.commission = commission
      this.valueDisponibiliteLots = disponibiliteLot
      this.valueCommodite = (Type.length == 0) ? null : Type
      this.promoteur = promoteur
      this.programme = programmes

      this.ModelCritere = false;
      if(this.Ancien == true){
        this.anciensPage = 1
        this.rechAncienWithCritere()
      }else {
        this.page = 1
        this.rechBienWithCritere()
      }
      // console.log(etage, date,zoneFiscale,exposition,commission,disponibiliteLot,Type,promoteur,programmes)
    },
    outsideA() {
      this.ModelAlert = false;
    },
    TRI(value) {
      console.log("slect", value);
    },
    comparateur() {  
    },
    VideComparateur() {     
    },
    myFunction() {
      var x = document.getElementById("filter_content");
       if(x.className=='filter_content'){
         x.className = "responsive"; 
       }else if(x.className=='responsive'){
         x.className = "filter_content"; 
       }
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    hasNumbers(t){
      var regex = /\d/g;
      return regex.test(t);
    },
    searchVille(query) {
        this.disableLocation = false;
        this.disableDepartment = true;
        if(this.isNumeric(query) || query == '2A' || query == '2B') {
            if(query.length >= 2) {
              this.searchVilleByCP({query: query}).then(res => {
                if(this.Location.length > 0){
                  this.LocationProjet = this.Location
                }
              })
            }
        }
        else {
            if(query.length > 2){
              this.searchVilleByName({query: query}).then(res => {
                if(this.Location.length > 0){
                  this.LocationProjet = this.Location
                }
              })
            }
        }
    },
    rechBienWithCritere() {
      this.$loading(true)
      window.scrollTo(0, 0);

      if(this.project_id != null) {
        this.setFiltersToProject(this.project_id)
      }

      this.searchQuery = {
        habiter: this.Habiter,
        investir: this.Investir,
        pinel: this.Pinel,
        lmnp: this.Lmnp,
        lmnpAmort: this.LmnpAmort,
        lmnpCensi: this.LmnpCensi,
        residence: this.residence,
        typeResidence: this.typeResidence,
        location : this.locationProjet,
        cp: this.departementProjet,
        minBudgetPT : this.minBudgetPT,
        maxBudgetPT : this.maxBudgetPT,
        minBudgetPM : this.minBudgetPM,
        maxBudgetPM : this.maxBudgetPM,
        type : this.valueType,
        typologie : this.valueTypologie,
        minSurfaceHab : this.minSurfaceHab,
        maxSurfaceHab : this.maxSurfaceHab,
        critere1 : this.critere1,
        critere2 : this.critere2,
        critere3 : this.critere3,
        critere4 : this.critere4,
        critere5 : this.critere5,
        etage : this.etage,
        exposition : this.exposition,
        valueCommodite : this.valueCommodite,
        Livraison : this.Livraison,
        commission : this.commission,
        zFiscale : this.zFiscale,
        valueDisponibiliteLots : this.valueDisponibiliteLots,
        promoteur: this.promoteur,
        programme: this.programme,
      }

      this.rechBienNeufWithFilter({ 
        habiter: this.Habiter,
        investir: this.Investir,
        pinel: this.Pinel,
        lmnp: this.Lmnp,
        lmnpAmort: this.LmnpAmort,
        lmnpCensi: this.LmnpCensi,
        residence: this.residence,
        typeResidence: this.typeResidence,
        location : this.locationProjet,
        cp: this.departementProjet,
        minBudgetPT : this.minBudgetPT,
        maxBudgetPT : this.maxBudgetPT,
        minBudgetPM : this.minBudgetPM,
        maxBudgetPM : this.maxBudgetPM,
        type : this.valueType,
        typologie : this.valueTypologie,
        minSurfaceHab : this.minSurfaceHab,
        maxSurfaceHab : this.maxSurfaceHab,
        critere1 : this.critere1,
        critere2 : this.critere2,
        critere3 : this.critere3,
        critere4 : this.critere4,
        critere5 : this.critere5,
        etage : this.etage,
        exposition : this.exposition,
        valueCommodite : this.valueCommodite,
        Livraison : this.Livraison,
        commission : this.commission,
        zFiscale : this.zFiscale,
        valueDisponibiliteLots : this.valueDisponibiliteLots,
        promoteur: this.promoteur,
        programme: this.programme,
        perPage : this.perPage,
        page : this.page,
        limit : this.limit,
      }).then(res => {
          this.totalRows=this.totalRowRechBienNeuf;
          
          this.$loading(false)
      });

    },
    rechAncienWithCritere() {
      this.$loading(true)
      window.scrollTo(0, 0);

      if(this.project_id != null) {
        this.setFiltersToProject(this.project_id)
      }
      this.searchQuery = {
        habiter: this.Habiter,
        investir: this.Investir,
        pinel: this.Pinel,
        lmnp: this.Lmnp,
        lmnpAmort: this.LmnpAmort,
        lmnpCensi: this.LmnpCensi,
        residence: this.residence,
        typeResidence: this.typeResidence,
        location : this.locationProjet,
        cp: this.departementProjet,
        minBudgetPT : this.minBudgetPT,
        maxBudgetPT : this.maxBudgetPT,
        minBudgetPM : this.minBudgetPM,
        maxBudgetPM : this.maxBudgetPM,
        type : this.valueType,
        typologie : this.valueTypologie,
        minSurfaceHab : this.minSurfaceHab,
        maxSurfaceHab : this.maxSurfaceHab,
        critere1 : this.critere1,
        critere2 : this.critere2,
        critere3 : this.critere3,
        critere4 : this.critere4,
        critere5 : this.critere5,
        etage : this.etage,
        exposition : this.exposition,
        valueCommodite : this.valueCommodite,
        Livraison : this.Livraison,
        commission : this.commission,
        zFiscale : this.zFiscale,
        valueDisponibiliteLots : this.valueDisponibiliteLots,
        promoteur: this.promoteur,
        programme: this.programme,
      }

      this.rechBienAncienWithFilter({ 
        habiter: this.Habiter,
        investir: this.Investir,
        pinel: this.Pinel,
        lmnp: this.Lmnp,
        lmnpAmort: this.LmnpAmort,
        lmnpCensi: this.LmnpCensi,
        residence: this.residence,
        typeResidence: this.typeResidence,
        location : this.locationProjet,
        cp: this.departementProjet,
        minBudgetPT : this.minBudgetPT,
        maxBudgetPT : this.maxBudgetPT,
        minBudgetPM : this.minBudgetPM,
        maxBudgetPM : this.maxBudgetPM,
        type : this.valueType,
        typologie : this.valueTypologie,
        minSurfaceHab : this.minSurfaceHab,
        maxSurfaceHab : this.maxSurfaceHab,
        critere1 : this.critere1,
        critere2 : this.critere2,
        critere3 : this.critere3,
        critere4 : this.critere4,
        critere5 : this.critere5,
        etage : this.etage,
        exposition : this.exposition,
        valueCommodite : this.valueCommodite,
        Livraison : this.Livraison,
        commission : this.commission,
        zFiscale : this.zFiscale,
        valueDisponibiliteLots : this.valueDisponibiliteLots,
        promoteur: this.promoteur,
        programme: this.programme,
        perPage : this.perPage,
        page : this.anciensPage,
        limit : this.limit,
      }).then(res => {
          this.totalRows=this.totalRowRechBienNeuf;
          
          this.$loading(false)
      });

    },

    setFiltersToProject(id) {
      this.setProjectFilters({
        project_id: id,
        habiter: this.Habiter,
        ancien: this.Ancien,
        investir: this.Investir,
        pinel: this.Pinel,
        lmnp: this.Lmnp,
        lmnpAmort: this.LmnpAmort,
        lmnpCensi: this.LmnpCensi,
        typeResidence: this.typeResidence,
        minBudgetPT : this.minBudgetPT,
        maxBudgetPT : this.maxBudgetPT,
        minBudgetPM : this.minBudgetPM,
        maxBudgetPM : this.maxBudgetPM,
        minSurfaceHab : this.minSurfaceHab,
        maxSurfaceHab : this.maxSurfaceHab,
        locationProjet: JSON.stringify(this.locationProjet),
        promoteur: JSON.stringify(this.promoteur),
        programme: JSON.stringify(this.programme),
        valueType : JSON.stringify(this.valueType),
        valueTypologie : JSON.stringify(this.valueTypologie),
        etage : this.etage,
        exposition : JSON.stringify(this.exposition),
        valueCommodite : JSON.stringify(this.valueCommodite),
        Livraison : JSON.stringify(this.Livraison),
        commission : this.commission,
        zFiscale : this.zFiscale,
        valueDisponibiliteLots : this.valueDisponibiliteLots
      }).then(res => {     
      })
    }

  },
  directives: {
    ClickOutside,
  },
  watch: {
    page:function(){          
        this.rechBienWithCritere();
    },
    anciensPage:function(){          
        this.rechAncienWithCritere();
    },
    RolesCurrentUser(value){
      this.UserRole = value
    }
  }
};
</script>

<style scoped lang="scss">
.page-content {
  display: inline;
  width: 100%;
  .navigation-bar {
     nav {
      background-color: #22ABC5;
      .text-dark {
        text-decoration: none;
      }
      a {
        text-decoration: none;
        color: #FFFFFF;
        
      }
      .dropdown {
        .btn-secondary {
          background-color: #22abc5;
          border-color: #22abc5;
          .color {
            color: #FF8C00;
          }
          
        }
        .btn-secondary:active {
          box-shadow: none;
          background-color: #FF8C00;
          .color {
            color: #FFFFFF !important;
          }
        }
        .btn-secondary:focus {
          box-shadow: none;
          background-color: #FF8C00;
           .color {
            color: #FFFFFF !important;
          }
        }
        
      }
    }
  }
  .filters-container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0px;
    height: auto;
    background-color: #f2fdff;
    align-items: center;
    padding-left: 2%;
    padding-right: 2%;
    margin-top: -20px;
    .filter {
      background: #EEEEEE;
      padding: 0px;
      padding-left: 15px;
      padding-right: 0px;
      border-radius: 50px;
      margin: 10px;
      span {
        color: #4E4E4E;
        font-size: 13px;
        font-weight: 600;
        svg {
          vertical-align: middle;
          margin-left: 5px;
          &:hover {
            cursor: pointer;
          }
        }
      }

    }
  }
  .filter_content{
    display: flex;
    margin-bottom: 20px;
    height: 100px;
    background-color: #22ABC5;
    align-items: center;
    padding-left: 5%;
    padding-right: 5%;
    
    .icon {
    display: none;
    }
    .div_btn_load {
      width: 7%;
      margin-right: 2px;
      .btn_load {
        background-color: #ececec;
        border-radius: 1px;
        border: none;
        outline: 0;
        color: #068596ba;
        padding: 6px;
        &:focus {
          .color {
            color: #ff8c00;
          }
          background-color: #dcecec;
        }
        .label {
          cursor: pointer;
          margin-left: 2px;
          padding-left: 3px;
          padding-right: 3px;
        }
      }
    }
    .active {
      width: 19%;
      margin-right: 10px;
      .btn {
        width: 100%;
        background-color: #ff8c00;
        border: none;
        outline: 0;
        color: #ffffff;
        padding: 10px 5px 10px 5px;
        font-size: 17px;
        font-family: Metropolis;
        border-radius: 5px;
        svg {
          path {
            fill: #FFFFFF;
          }
        }
        .label {
          cursor: pointer;
          color: #ffffff;
          margin-left: 2px;
          padding-left: 20px;
          padding-right: 12px;
          font-size: 15px;
        }
        .color {
          color: #ffffff !important;
          margin-right: 15px;
        }
      }
      .btn_star {
        width: 150%;
        position: relative;
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;
        .label {
          display: inline;
        }
      }
      .btn_add {
        background-color: #068596ba;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;
        .label {
          color: #ececec;
          margin-left: 2px;
          padding-left: 3px;
        }
      }
    }
    .div_btn {
      width: 19%;
      margin-right: 10px;
      &:focus {
        .btn {
          color: #ff8c00;
          svg {
            path {
              fill: #ffffff;
            }
          }
        }
      }
      
      .btn {
        width: 100%;
        background-color: #22abc5;
        border: none;
        outline: 0;
        color: #ffffff;
        padding: 10px 5px 10px 5px;
        font-family: Metropolis;
        font-size: 17px;
        border-radius: 5px;
        &:focus {
          .color {
            color: #ff8c00;
          }
          background-color: #FF8C00;
        }
        :hover {
          cursor: pointer;
        }
        .label {
          margin-left: 2px;
          padding-left: 20px;
          padding-right: 12px;
          font-size: 15px;
        }
        .color {
          color: #ff8c00 !important;
          margin-right: 15px;
        }
      }
      .btn_star {
        width: 50%;
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;
        .label {
          display: none;
        }
        &:focus {
          width: 100%;
          .label {
            display: inline;
          }
        }
      }
      .btn_add {
        background-color: #068596ba;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ececec;
        padding: 6px;
        &:focus {
          .color {
            color: #ff8c00;
          }
        }
        .label {
          margin-left: 2px;
          padding-left: 3px;
        }
      }
    }

  }
   .responsive{
    width: 100%;
    display: flex;
    //margin-top: 10px;
    margin-bottom: 20px;
    .icon {
    display: none;
    }
    .div_btn_load {
      width: 7%;
      margin-right: 2px;
      .btn_load {
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #068596ba;
        padding: 6px;
        &:focus {
          .color {
            color: #ff8c00;
          }
          background-color: #dcecec;
        }
        .label {
          margin-left: 2px;
          padding-left: 3px;
          padding-right: 3px;
          font-size: 12px;
        }
      }
    }
    .active {
      width: 19%;
      margin-right: 1px;
      .btn {
        width: 100%;
        background-color: #dcecec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;
        .label {
          color: #068596ba;
          margin-left: 2px;
          padding-left: 3px;
          padding-right: 3px;
              font-size: 12px;
        }
      }
      .btn_star {
        width: 150%;
        position: relative;
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;
        .label {
          display: inline;
        }
      }
      .btn_add {
        background-color: #068596ba;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;
        .label {
          color: #ececec;
          margin-left: 2px;
          padding-left: 3px;
        }
      }
    }
    .div_btn {
      width: 19%;
      margin-right: 1px;
      &:focus {
        .btn {
          color: #ff8c00;
          font-family: Metropolis;
        }
      }
      .btn {
        width: 100%;
        background-color: #ececec;
        border: none;
        outline: 0;
        color: #068596ba;
        padding: 10px 5px 10px 5px;
        font-family: Metropolis;
        font-size: 18px;
        border-radius: 5px;
        &:focus {
          .color {
            color: #ff8c00;
          }
          background-color: #dcecec;
        }
        .label {
          margin-left: 2px;
          padding-left: 3px;
          padding-right: 3px;
        }
      }
      .btn_star {
        width: 50%;
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;
        .label {
          display: none;
        }
        &:focus {
          width: 100%;
          .label {
            display: inline;
          }
        }
      }
      .btn_add {
        background-color: #068596ba;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ececec;
        padding: 6px;
        &:focus {
          .color {
            color: #ff8c00;
          }
        }
        .label {
          margin-left: 2px;
          padding-left: 3px;
        }
      }
    }

  }
  .container {
    margin: 2%;
    .content {
      width: 100%;
      display: flex;
      //margin-top: 10px;
      margin-bottom: 20px;
      .icon {
      display: none;
      }
      .Card_content{
        width: 100%;
        display: inline;
        padding: 20px;
    background: #F2FDFF;
        .card {
        //position: relative;
        display: inline;
        width: 100%;
        flex-direction: row;
        .row{
          margin: 5px;
          background: #ffffff;
          display:flex
        }
        .card-blocSlide{
          //position: relative;
          display: block;
          width:30%;
          color: #aba3a3;
          text-align: right;
          margin: 5px;
          .contentblue {
              background-color: #068596ba;
              .buttonComparateur {
                background-color: #068596ba;
                color: white;
                padding: 5px;
                border: none;
                outline: 0;
                width: 100%;
                &:hover {
                  color: #ff8c00;
                }
              }  
            }
        }
        .card-blocTitle {
          //position: relative;
          display: block;
          width:40%;
          color: #aba3a3;
          text-align: left;
          margin: 15px 0px 15px 15px;
          span {
            color: #22abc5;
            font-family: 'Seoge UI-bold';
          }
          svg {
            color: #22abc5;
            margin-right: 3px;
          }
          .cotent_star {
              //position: absolute;
              right: 0;
              text-align: left;
              margin-top: 7px;
              font-family: 'Seoge UI';
            }
            .ligne {
              margin-top: 5px;
              margin-bottom: 20px;
              width: 100%;
            }
            .bluecolor {
              color: #22abc5;
              font-size: 18px;
              font-family: 'Seoge UI-bold';
              margin-top: -6px
            }
            div {
              min-width: 250px;
            }
        }
        .card-blocData {
          //position: relative;
          display: block;
          width:33%;
          color: #aba3a3;
          text-align: right;
          margin: 15px 15px 15px 0px;
          text-align: right;
          color: #aba3a3;

            .titlecolor {
              color: #6f6767;
            }
            .price {
              color: #ff8c00;
              font-weight: bold;
              font-size: 24px;
              font-family: 'Seoge UI-Bold';
            }
            .program {
              color: #22ABC5;
              text-transform: uppercase;
              font-family: 'Seoge UI-bold';
              font-size: 20px;
            }
            .promoteur {
              color: #22ABC5;
              font-family: 'Seoge UI-bold';
              font-size: 20px;
              margin-top: 0px;
            }
            .alert {
              background-color: #ff8c00;
              border-radius: 5px;
              border: none;
              outline: 0;
              color: white;
              padding: 6px;
              padding-top: 10px;
              padding-bottom: 10px;
              cursor: pointer;
              padding-right: 20px;
              padding-left: 20px;
              font-family: Metropolis;
            }
            .comparateur {
              background-color: #22abc5;
              border-radius: 4px;
              border: none;
              outline: 0;
              color: white;
              padding: 6px;
              padding-top: 10px;
              padding-bottom: 10px;
              cursor: pointer;    
              margin-right: 5px;
              padding-right: 15px;
              padding-left: 15px;
              font-family: Metropolis;
            }
            div {
              margin-top: 10px;
              font-weight: bold;
              color: #888888;
              font-family: 'Seoge UI-bold';
            }
          
          
        }
      }
      }
      .text-result {
        font-size: 17px;
        color: #888888;
        font-family: 'Seoge UI-400';
      }
      .text-blue {
        color: #068596ba;
        margin: 0px;
      }
      .col2 {
        width: 50%;
        .Alert {
          text-align: end;
          .alert {
            background-color: #FB4444;
            border-radius: 5px;
            border: none;
            outline: 0;
            color: white;
            padding: 10px;
            width: 190px;
            font-family: Metropolis;
            font-size: 16px;
          }
        }
        .row3 {
          text-align: end;
          display: flex;
          .btn {
            width: 95%;
            background-color: #e4e3e3;
            border-radius: 5px;
            border: 1px solid #e4e3e3;
            outline: 0;
            color: #857a7a;
            padding: 5px;
            padding-top: 10px;
            padding-bottom: 10px;
          }
          .select {
            width: 100%;
            color: red;
          }
          .blue {
            background-color: #22ABC5;
            color: white;
            width: 79%;
          }
          .pink {
            background-color: #22ABC5;
            color: white;
            font-size: 20px;
            font-family: 'Seoge UI';
          }
          .span {
            margin-top: 5%;
            width: 20%;
            color: #888888;
            font-size: 20px;
            font-family: 'Seoge UI';
          }
        }
      }
      .width1 {
        width: 18%;
      }
      .width2 {
        width: 30%;
      }
      .width3 {
        width: 42%;
      }
      
    }
  }
  
}

@media screen and (max-width: 768px) {
  
  .page-content {
    .filter_content{
      display: none;
    }
    .responsive{
    width: 50%;
    top: 32px;
    left: 2px;
    padding-left: 30px;
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #ced9da;
    overflow: hidden;
    box-shadow: 5px 5px 10px grey;
    position: absolute;
    z-index: 11;
    transition: all 0.25s;
    -webkit-transition: all 0.25s;
    font-weight: 400;
    text-align: left;
    font-size: 12px;
    margin: 0px;
    display: inline;
    .div_btn_load {
      width: 7%;
      margin-right: 2px;
      .btn_load {
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #068596ba;
        padding: 6px;
        &:focus {
          .color {
            color: #ff8c00;
          }
          background-color: #dcecec;
        }
        .label {
          margin-left: 2px;
          padding-left: 3px;
          padding-right: 3px;
        }
      }
    }
    .active {
      width: 50%;
      margin-right: 1px;
      .btn {
        width: 100%;
        background-color: #dcecec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;
        .label {
          color: #068596ba;
          margin-left: 2px;
          padding-left: 3px;
          padding-right: 3px;
        }
      }
      .btn_star {
        width: 150%;
        position: relative;
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;
        .label {
          display: inline;
        }
      }
      .btn_add {
        background-color: #068596ba;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;
        .label {
          color: #ececec;
          margin-left: 2px;
          padding-left: 3px;
        }
      }
    }
    .div_btn {
      width: 50%;
      //margin-right: 1px;
      margin:2px;
      &:focus {
        .btn {
          color: #ff8c00;
        }
      }
      .btn {
        width: 100%;
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #068596ba;
        padding: 6px;
        &:focus {
          .color {
            color: #ff8c00;
          }
          background-color: #dcecec;
        }
        .label {
          margin-left: 2px;
          padding-left: 3px;
          padding-right: 3px;
        }
      }
      .btn_star {
        width: 50%;
        background-color: #ececec;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ff8c00;
        padding: 6px;
        .label {
          display: none;
        }
        &:focus {
          width: 100%;
          .label {
            display: inline;
          }
        }
      }
      .btn_add {
        background-color: #068596ba;
        border-radius: 15px;
        border: none;
        outline: 0;
        color: #ececec;
        padding: 6px;
        &:focus {
          .color {
            color: #ff8c00;
          }
        }
        .label {
          margin-left: 2px;
          padding-left: 3px;
        }
      }
    }
    }
    .content {
      .icon {
      float: left;
      display: block;
      border: 1px solid white;
      height: 25px;
      width: 30px;
      color: #068596ba;
      border-radius: 5px;
      outline: 0;
    }
      .div_btn {
        .btn {
          font-size: 11px;
          height: 40px;
        }
        .btn_star {
          font-size: 12px;
          height: 40px;
        }
        .btn_add {
          font-size: 11px;
          height: 40px;
        }
      }
      .div_btn_load {
        .btn_load {
          font-size: 12px;
          height: 40px;
        }
      }
      .Card_content{
        .card{
          .row {
              display: flex;
              
          }
          flex-direction: column;
          .card-blocSlide{
            width: 80%;
          }
          .card-blocTitle{
              width: 80%;
              text-align: left;
              .cotent_star{
                text-align: left;
              }
          }
          .card-blocData{
              width: 80%;
              text-align: left;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 425px) {
  .page-content {
    .responsive{
    width: 80%;
    .div_btn {
        width: 65%;
      }
      .active{
         width: 65%;
      }
    }
    .container {
      .content {
        display: inline-block;
        .col2 {
          width: 100%;
          .row3 {
            .select {
              width: 100%;
              .row {
                margin: 0;
                select {
                  .selectBlue {
                    width: 100% !important;
                    font-size: 20px;
                  }
                }
              }
            }
          }
        }
      }
    }
    .content {
    display: inline-block;
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
    .Card_content{
        .card{
          .row {
              display: inline-block !important;
          }
          .card-blocSlide{
            width: 90% !important;
            
          }
          .card-blocTitle{
            div{
              min-width: 150px;
            }
            width: 100%;
            font-size:12px
          }
          .card-blocData{
             width: 80% !important;
          }
        }
    }
      .div_btn {
        width: 50%;
        margin-left: 20%;
        margin-right: 20%;
      }
      .col2 {
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 0;
        .row3 {
          display: inline;
          .select {
            width: 95%;
          }
        }
      }
      .width2 {
        width: 100%;
      }
      .width3 {
        width: 100%;
        margin: 0px;
      }
    }
  }
}
.modal-backdrop {
  z-index: 999;
  position: absolute;
  .modal {
    width: 200px;
    background-color: #fff;
    border-radius: 3px;
    padding: 15px;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11);
    .btn {
      width: 50px;
      border-radius: 5px;
      border: none;
      color: white;
      background-color: #068596ba;
      padding: 10px;
      margin-left: 70%;
      outline: 0;
      &:focus {
        border: none;
        background-color: #ff8c00;
      }
    }
  }
}
@media screen and (max-width: 375px) {
  .modal-backdrop {
  position: initial;
  .modal{
    width: 150px;
  }
  }
}
.titre_content {
    text-align: center;
    font-size: 23px;
    color: #068596ba;
    margin: 14px;
} 
.Detailscontent {
	display: inline;
	width: 100%;
	color: #6f6767;
}
.Detailscontent .title {
	display: flex;
	width: 100%;
	margin-bottom: 13px;
  font-weight: 900;
  color: #072025;
  font-size: 15px !important;
}

.gras {
    font-weight: bold;
    font-size: 18px;
}
.colorBl {
    color: #068596;
}
.colorB {
    color: black;
}

.blackcolor {
    color: rgb(48, 46, 46);
    font-size: 19px;
}

.colorIcon {
    color: #068596ba;
    font-size: 18px;
    list-style-type: circle;
}

details {
	display:block; 
	width:100%;
	margin:10px 0;
}
summary {
	display: block;
  color: white;
  border-radius: 5px;
  padding: 5px;
  cursor: pointer;
  font-weight: lighter;
}
summary:focus {
  outline: transparent;
}

summary::-webkit-details-marker {
   color:#FF0000; 
   background:#FFFFFF; 
}

details[open] summary::-webkit-details-marker {
   color:#0000FF; 
   background:#00FFFF;
}
summary::-webkit-details-marker {
   display: none
}

summary:after {
   content: "+";
   color: white;
   float: left;
   font-size: 1.5em;
   font-weight: lighter;
   margin: -5px 5px 0 0;
   padding: 0;
   text-align: center;
   width: 20px;
}

details[open] summary:after {
   content: "-";
  color: #FFFFFF
}
.details {
    margin: 0 auto;
    padding-right: 15px;
    padding-left: 15px;
}

.details h2 {
    font-size: 34px;
    width: 100%;
    padding: 20px 0 0;
    text-align: center;
    font-size: 26px;
    color: #005cac;
}

.property-childs-list {
    padding: 0;
    margin-bottom: 0;
}

.property-childs-list .property-child:nth-child(odd) {
    background-color: rgba(6,43,78,.05);
}

.property-childs-list .property-child {
    padding: 10px;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: nowrap;
}


.property-childs-list .property-child .btn-detail-sibling {
    padding-right: 55px;
    transition: all .3s;
}

.property-childs-list .property-child-title {
    font-size: 16px;
}

.property-childs-list .property-child-price {
    font-weight: 700;
    font-size: 20px;
    text-align: right;
    color: #f28e22
}

.property-childs-list .property-child-rate strong {
    color: #005cac;
}

.property-childs-list .property-child-rate .value {
    color: #762986;
    font-weight: 700;
}
.property-childs-list .property-child:hover .property-child-price, .property-childs-list .property-child:hover .property-child-pricem2 {
    /* transform: translateX(-80px); */
    transition: all .3s;
}

.property-childs-list .property-child-pricem2 {
    font-size: 13px;
    text-align: right;
}

.property-childs-list .property-child .btn-detail {
    display: inline-block!important;
    position: relative;
    right: 15px;
    top: 50%;
    bottom: 0;
    height: 30px;
    margin: 0!important;
    width: auto!important;
    padding: 7px 5px!important;
    vertical-align: middle;
    transform: translateY(-50%);
    cursor: pointer;
}

.property-childs-list .property-child .btn-detail span {
    line-height: 38px;
    opacity: 0;
    width: 1px;
    display: inline-block;
    padding-left: 5px;
}

.property-childs-list .property-child .btn-detail i {
    display: inline-block;
    vertical-align: top;
    line-height: 31px;
    margin-left: 0px;
    padding-left: 0px;
    margin-right: 5px
}

.fa-angle-right:before {
    content: "\f105";
    font-size: 20px;
}

.btn-secondary, .prospace .container .btn[type=submit]:not(.btn-danger) {
    background-color: #f28e22;
    border-color: #f28e22;
}
.btn-secondary:hover, .prospace .container .btn:hover[type=submit]:not(.btn-danger) {
    background-color: #22ABC5;
    color: #fff;
    border-color: #22ABC5;
}
</style>
<style>
 /* 23.Navs */
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: white;
  background-color: #33b4cd; }

.nav-pills .nav-link {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin: 5px;
  padding: 10px;
  color: white !important; }
  .nav-pills .nav-link .folderIcon {
    color: #1E8A9E !important; }

.nav-link {
  padding: 0.5rem 1rem; }
  @media (max-width: 767px) {
    .nav-link {
      padding: 0.5rem 0.5rem; } }
  .nav-link.active {
    color: #33b4cd; }

.page-item {
  padding: 5px; }
  @media (max-width: 767px) {
    .page-item {
      padding: 3px; } }
  .page-item .page-link {
    outline: initial !important;
    box-shadow: initial !important;
    line-height: 1.7;
    text-align: center;
    border-radius: 5px;
    width: 30px;
    height: 30px;
    font-size: 16px;
    font-family: Metropolis;
    }
    @media (max-width: 575px) {
      .page-item .page-link {
        min-width: 30px;
        height: 30px;
        line-height: 0.9;
        font-size: 0.76rem; } }
    .page-item .page-link.next {
      background: #33b4cd;
      color: white;
      border: 1px solid #33b4cd; }
    .page-item .page-link.prev, .page-item .page-link.prev {
      background: #33b4cd;
      border: 1px solid #33b4cd;
      color: white; }
    .page-item .page-link:first, .page-item .page-link.last {
      background: transparent;
      color: #33b4cd;
      border: 1px solid #33b4cd;
      border-radius: 30px; }
      .page-item .page-link:first:hover, .page-item .page-link.last:hover {
        background: #33b4cd;
        color: white;
        border: 1px solid #33b4cd; }
    .page-item .page-link:hover {
      cursor: pointer;
      background-color: #ff8c00;
      color: #ffffff; }
  .page-item.active .page-link {
    background: #ff8c00;
    color: white; 
    border-radius: 5px;
    width: 30px;
    height: 30px;
    font-size: 16px;
    font-family: Metropolis;
    }
  .page-item.disabled .page-link {
    /*border-color: $separator-color;*/
    border: initial;
    color: #d7d7d7;
    background: transparent; }
  .page-item[role=separator] .page-link {
    color: #212121; }

.page-link {
  background-color: #22abc5;
  border-color: transparent;
  color: #ffffff; }

.btn-sm.page-link {
  padding: 0.5rem 0.5rem; }

.pagination-lg .page-item {
  padding: 15px; }
  @media (max-width: 767px) {
    .pagination-lg .page-item {
      padding: 3px; } }
  .pagination-lg .page-item .page-link {
    min-width: 50px;
    height: 50px; }
    @media (max-width: 767px) {
      .pagination-lg .page-item .page-link {
        min-width: 38px;
        height: 38px;
        padding: 0.55rem 0;
        line-height: 1.5;
        font-size: 0.8rem; } }
    @media (max-width: 575px) {
      .pagination-lg .page-item .page-link {
        min-width: 30px;
        height: 30px;
        line-height: 0.9;
        font-size: 0.76rem; } }

.pagination-sm .page-item {
  padding: 6px; }
  @media (max-width: 767px) {
    .pagination-sm .page-item {
      padding: 3px; } }
  .pagination-sm .page-item .page-link {
    min-width: 30px;
    height: 30px;
    line-height: 0.9;
    font-size: 0.76rem; }
    .pagination {
      display: -webkit-box!important;
    -webkit-box-pack: center;
    padding-left: 0;
    list-style: none;
    border-radius: .25rem;
    }
    .page-item .page-link {
    outline: initial !important;
    box-shadow: initial !important;
    line-height: 1.7;
    text-align: center;
}

.vueperslides__arrow, .vueperslides__arrow svg  {
    font-size: 5px;
    background: #22abc5;
}
.vueperslides__parallax-wrapper {
  padding-bottom: 50% !important;
}


/* common */
.ribbon {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
}
.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: '';
  display: block;
  border: 5px solid #2980b9;
}
.ribbon span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 15px 0;
  background-color: #3498db;
  box-shadow: 0 5px 10px rgba(0,0,0,.1);
  color: #fff;
  font: 700 18px/1 'Lato', sans-serif;
  text-shadow: 0 1px 1px rgba(0,0,0,.2);
  text-transform: uppercase;
  text-align: center;
}


/* bottom right*/
.ribbon-bottom-right {
  bottom: -10px;
  right: -10px;
}
.ribbon-bottom-right::before,
.ribbon-bottom-right::after {
  border-bottom-color: transparent;
  border-right-color: transparent;
}
.ribbon-bottom-right::before {
  bottom: 0;
  left: 0;
}
.ribbon-bottom-right::after {
  top: 0;
  right: 0;
}
.ribbon-bottom-right span {
  left: -25px;
  bottom: 30px;
  transform: rotate(-45deg);
}


/* common */

.multiselect {
  margin-bottom: 15px;
}

.multiselect__tags {
    min-height: 43px;
    display: block;
    border-radius: 5px;
    border: 1px solid #f2fdff;
    background: #fff;
    font-size: 13px;
    padding: 7px;
}
    
.multiselect__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 15px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #22abc5;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
}
.multiselect__option--highlight {
    background: #22abc5;
    outline: none;
    color: #fff;
    font-size: 14px;
    font-family: Metropolis;
}
.multiselect__element {
    font-size: 12px;
}

.multiselect__tag-icon:after {
    content: "\D7";
    color: #ff8c00;
    font-size: 14px;
}

.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: #ff8c00;
}

.multiselect__option--highlight:after {
    content: attr(data-select);
    background: #ff8c00;
    color: #fff;
}

.multiselect__placeholder {
    color: #adadad;
    display: inline-block;
    margin-bottom: 10px;
    padding-top: 2px;
    font-family: Metropolis;
}

.multiselect__option {
    display: block;
    padding: 12px;
    min-height: 40px;
    line-height: 16px;
    text-decoration: none;
    text-transform: none;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    white-space: nowrap;
    font-family: Metropolis;
    font-size: 12px;
}

.multiselect__select {
    position: absolute;
    width: 40px;
    height: 38px;
    right: -10px;
    top: 1px;
    padding: 4px 8px;
    text-align: center;
    transition: transform .2s ease;
}

.multiselect__select:before {
    position: relative;
    right: 0;
    top: 65%;
    color: #22abc5;
    margin-top: 4px;
    border-color: #22abc5 transparent transparent;
    border-style: solid;
    border-width: 5px 5px 0;
    content: "";
}

</style>
